import { NewsAO } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const allNewsAOReducer: RemoteReducer<NewsAO[]> =
  createRemoteReducer("allNewsAO")
